
import { IsotopeDto, CreateIsotopeDto, UpdateIsotopeDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { isotopeService, IsotopesFilters } from '@services/IsotopeService'

const { reducer, actions, thunks } = baseCrudReducer<
  IsotopeDto,
  CreateIsotopeDto,
  UpdateIsotopeDto,
  IsotopesFilters
>('isotope', isotopeService)

export default reducer

export const { setFilters: setIsotopeFilters } = actions

export const {
  getAll: getIsotopes,
  create: createIsotope,
  update: updateIsotope,
  remove: removeIsotope,
} = thunks
